module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C508"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("PREFACE")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "P2"
  }, [_vm._v("Years of teaching Mathematical Methods of Physics at the University of Michigan to seniors and first-year graduate students convinced me that existing textbooks don’t do an adequate job in the area of vector analysis: all too often, their treatment is a repetition of what students had already seen in earlier courses, with little or no insight into the essentially geometrical structure of the subject. For this reason, I got into the habit of substituting my own discussion for whatever the textbook contained, a few years ago even going so far as to distribute some informal notes under the title “Geometrical Vectors.”")])]), _c('p', {
    staticClass: "C514"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("Reactions to those notes, on the part of both colleagues and students, were enthusiastic, and the thought of rewriting the material in a form suitable for publication naturally followed. It has, however, been clear to me from the beginning that the resulting book can only have an appreciable market if it is priced so that students can buy it "), _c('em', [_vm._v("in addition")]), _vm._v(" to one of the standard textbooks. Conversations with experts indicated that such a goal ")]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("was, indeed, attainable in a paperback produced from my camera-ready copy, and so I got to work; three years later, the result of that work is before you.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "C514"
  }, [_vm._v("In planning the book, I had to decide whether to call it “Geometrical Vectors” and limit its coverage correspondingly, or to go for “Geometrical Vectors and Tensors,” discuss both subjects, and in doing so double its size. If in fact I opted for the first, it was not without a great deal of sadness, because tensor analysis is so beautiful, while at the same time its elementary treatments tend to be no better than those of vector analysis. Yet the practical demand for physicists to understand tensors is quite small compared to the ubiquitous use of vectors; and I was afraid that the consequent increase in price might make the resulting book inaccessible to what is, as I see it, its primary audience.")]), _vm._v(" "), _c('p', {
    staticClass: "C515"
  }, [_vm._v("My enormous indebtedness in this work is to so many that it can only be acknowledged generically. And so my deep and heartfelt appreciation goes, first, to my students for constantly asking questions; second, to my teachers for teaching me to do the same; and last but by no means least, to my many colleagues (including a number of anonymous reviewers) in the crucible of whose conversation my present understanding was refined. I sincerely hope that others, too, may now find this understanding useful.")]), _vm._v(" "), _c('p', {
    staticClass: "C516"
  }, [_c('em', [_vm._v("Gabriel Weinreich")])]), _vm._v(" "), _c('p', {
    staticClass: "C494"
  }, [_c('em', [_vm._v("Ann Arbor")])]), _vm._v(" "), _c('p', {
    staticClass: "C494"
  }, [_c('em', [_vm._v("December 1997")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8015dbf0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/05_Preface.vue
// module id = 69
// module chunks = 0